import { render, staticRenderFns } from "./RemitaResponse.vue?vue&type=template&id=ea6cebbe&scoped=true&"
import script from "./RemitaResponse.vue?vue&type=script&lang=js&"
export * from "./RemitaResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6cebbe",
  null
  
)

export default component.exports